'use strict';

var toObject = require('../internals/to-object');

var aFunction = require('../internals/a-function');

var definePropertyModule = require('../internals/object-define-property');

var FORCED = require('../internals/forced-object-prototype-accessors-methods'); // `Object.prototype.__defineGetter__` method
// https://tc39.github.io/ecma262/#sec-object.prototype.__defineGetter__


if (require('../internals/descriptors')) {
  require('../internals/export')({
    target: 'Object',
    proto: true,
    forced: FORCED
  }, {
    __defineGetter__: function __defineGetter__(P, getter) {
      definePropertyModule.f(toObject(this), P, {
        get: aFunction(getter),
        enumerable: true,
        configurable: true
      });
    }
  });
}